import Vue from "vue";
import Router from "vue-router";
import storage from "@/service/storage-service";
import wx from "weixin-js-sdk";
import resource from '../service/resource-service'
import {
  param
} from "jquery";
Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [{
    name: "login",
    path: "/",
    component: resolve => require(["@/components/login"], resolve),
    meta: {
      keepAlive: true
    }
  },
  {
    name: "productList",
    path: "/productList",
    component: resolve => require(["@/components/productList"], resolve)
  },
  {
    name: "login",
    path: "/login",
    component: resolve => require(["@/components/login"], resolve)
  },
  {
    name: "home",
    path: "/home",
    component: resolve => require(["@/components/home"], resolve),
    meta: {
      keepAlive: true
    }
  },
  {
    name: "consulting",
    path: "/consulting",
    component: resolve => require(["@/components/consulting"], resolve)
  },
  {
    name: "cart",
    path: "/cart",
    component: resolve => require(["@/components/cart"], resolve)
  }, {
    name: "productDetail",
    path: "/productDetail",
    component: resolve => require(["@/components/productDetail"], resolve),
  }, {
    name: "mine",
    path: "/mine",
    component: resolve => require(["@/components/mine"], resolve)
  }, {
    name: "checkOrder",
    path: "/checkOrder",
    component: resolve => require(["@/components/checkOrder"], resolve),
  }, {
    name: "nowCheckOrder",
    path: "/nowCheckOrder",
    component: resolve => require(["@/components/nowCheckOrder"], resolve),
  },
  {
    name: "locationList",
    path: "/locationList",
    component: resolve => require(["@/components/locationList"], resolve)
  },
  {
    name: "locationEdit",
    path: "/locationEdit",
    component: resolve => require(["@/components/locationEdit"], resolve)
  },
  {
    name: "order",
    path: "/order",
    component: resolve => require(["@/components/order"], resolve)
  },
  {
    name: "articleDetail",
    path: "/articleDetail",
    component: resolve => require(["@/components/articleDetail"], resolve),
  },
  {
    name: "myInfo",
    path: "/myInfo",
    component: resolve => require(["@/components/myInfo"], resolve)
  },
  {
    name: "gradeList",
    path: "/gradeList",
    component: resolve => require(["@/components/gradeList"], resolve)
  },
  {
    name: "record",
    path: "/record",
    component: resolve => require(["@/components/record"], resolve)
  }, {
    name: "cumulative",
    path: "/cumulative",
    component: resolve => require(["@/components/cumulative"], resolve)
  }, {
    name: "rankUp",
    path: "/rankUp",
    component: resolve => require(["@/components/rankUp"], resolve)
  }, {
    name: "myCustomer",
    path: "/myCustomer",
    component: resolve => require(["@/components/myCustomer"], resolve)
  }, {
    name: "myInformation",
    path: "/myInformation",
    component: resolve => require(["@/components/myInformation"], resolve)
  }, {
    // 订单详情
    name: "orderDetail",
    path: "/orderDetail",
    component: resolve => require(["@/components/orderDetail"], resolve)
  }, {
    // 退款
    name: "refundApply",
    path: "/refundApply",
    component: resolve => require(["@/components/refundApply"], resolve)
  }, {
    // 退款详情
    name: "refundDetail",
    path: "/refundDetail",
    component: resolve => require(["@/components/refundDetail"], resolve)
  }, {
    // 物流信息
    name: "logisticsInformation",
    path: "/logisticsInformation",
    component: resolve => require(["@/components/logisticsInformation"], resolve)
  }, {
    // 评论
    name: "comment",
    path: "/comment",
    component: resolve => require(["@/components/comment"], resolve)
  }, {
    name: "message",
    path: "/message",
    component: resolve => require(["@/components/message"], resolve)
  }, {
    name: "express",
    path: "/express",
    component: resolve => require(["@/components/express"], resolve)
  }, {
    name: "system",
    path: "/system",
    component: resolve => require(["@/components/system"], resolve)
  }, {
    name: "myCode",
    path: "/myCode",
    component: resolve => require(["@/components/myCode"], resolve)
  }, {
    name: "commentList",
    path: "/commentList",
    component: resolve => require(["@/components/commentList"], resolve)
  }, {
    name: "explain",
    path: "/explain",
    component: resolve => require(["@/components/explain"], resolve)
  }, {
    name: "pay",
    path: "/pay",
    component: resolve => require(["@/components/pay"], resolve)
  },
  {
    name: "livePage",
    path: "/livePage",
    component: resolve => require(["@/components/LivePage"], resolve)
  },
  {
    name: "LiveGoodsList",
    path: "/liveGoodsList",
    component: resolve => require(["@/components/LiveGoodsList"], resolve)
  }
  ],
});


router.beforeEach(function (to, from, next) {
  // let user = {
  //   birthday: null,
  //   creditNumber: null,
  //   expires: 0,
  //   icon: null,
  //   mobilePhone: '13432865151',
  //   openId: "o8gLCs8XzywoLGrelxwWTxnLa9LE",
  //   organizationId: null,
  //   password: null,
  //   refresh: false,
  //   roleId: null,
  //   sessionKey: null,
  //   status: null,
  //   token: "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI4MTc4MTE5NDc2MjQ4NTc2MDAiLCJleHAiOjE2MzAyMTg0MDd9.uRpfaSX2b3dcsRg5on0PCEzYIq7AxrfmTSJLbWTGKcntQbOm0hJ-f0iFkBUJ4sd7GVptf7LwMghH3blbXBRtFA",
  //   type: "member",
  //   userId: "824349287767867392",
  //   userName: "哈哈哈",
  //   wxAccessToken: "44_-nt6qkqgYU999UkGAZiwVMxPNAY1_mGNVQFjW1fcndoZZBZ3Q9kWyGzgYP4iMf-aMcP0vHWltX3Q_bw6revNqg",
  // }
  // storage.set('user', user)
  // storage.set('userId', '824349287767867392')
  

  if (to.path != "/productDetail" && to.path != "/articleDetail" && to.path != "/consulting") {
    
    document.title = '灸大夫商城'
    wx.ready(function () {
      wx.checkJsApi({
        jsApiList: ["onMenuShareAppMessage", "onMenuShareTimeline", 'showOptionMenu', "updateAppMessageShareData", "updateTimelineShareData"],
        success: function (res) { },
      });
      let link = location.href;
      if (link.indexOf("/?") > 0) {
        link = "http://jdfmall.jiudaifu.com/home?parentUserId=" + to.query.parentUserId;
      }
      let options = {
        title: '灸大夫商城', // 分享标题
        desc: '改变「艾」你的方式，呵护我们的健康。',
        link: link, // 分享链接
        imgUrl: 'https://i.ibb.co/D4tzjWZ/logo.png', // 分享图标
        success: (res) => {
          console.log(res);
        },
      }
      if (wx.onMenuShareAppMessage) { //微信文档中提到这两个接口即将弃用，故判断
        wx.onMenuShareAppMessage(options);
        wx.onMenuShareTimeline(options);//1.0分享到朋友圈
        console.log(123)
      } else {
        wx.updateAppMessageShareData(options);//1.4 分享到朋友
        wx.updateTimelineShareData(options);//1.4分享到朋友圈
        console.log(456)
      }
      console.log("wx", wx);
    });
  }
  // if (to.path != "/" || to.path != "/home"){
  //   console.log(11111111111111111)
  //   next({
  //     path: '/home',
  //     query: to.query
  //   })
  // }
  if (to.path != "/login" && to.path != "/pay" && to.path != '/home' && to.path != '/consulting' && to.path != '/productDetail' && to.path != '/articleDetail' && to.path != '/home') {
    console.log(222222222)
    
    if (!storage.get('userId') || !storage.get('user')) {
      next({
        path: '/login',
        query: to.query
      })
    } else {
      console.log(1)
      if (!to.query.parentUserId) {
        console.log(21)
        let params = to.query
        if (from.query.parentUserId && (from.query.parentUserId == storage.get('userId'))) {
          console.log(31);
          params.parentUserId = from.query.parentUserId
        } else {
          console.log(32);
          params.parentUserId = storage.get('userId')
        }
        next({
          path: to.path,
          query: params
        })
      } else {
        console.log(22)
        if (to.query.parentUserId != storage.get('userId')) {
          console.log(41);
          let params = to.query
          
          params.parentUserId = storage.get('userId')
          next({
            path: to.path,
            query: params
          })
        } else {
          console.log(42);
          next()
        }
      }
    }
  } else {
     if (!storage.get('userId') || !storage.get('user')) {
       next()
       if (!to.query.parentUserId) {
         next()
       } else {
         storage.set('parentUserId', to.query.parentUserId)
         console.log('设置了parentUserId');
          next()
       }
     } else {
       if (!to.query.parentUserId) {
         let params = to.query
         if (from.query.parentUserId && (from.query.parentUserId == storage.get('userId'))) {
           params.parentUserId = from.query.parentUserId
         } else {
           params.parentUserId = storage.get('userId')
         }
         next({
           path: to.path,
           query: params
         })
       } else {
         
         if (to.query.parentUserId != storage.get('userId')) {
           
           let params = to.query

           params.parentUserId = storage.get('userId')
           next({
             path: to.path,
             query: params
           })
         } else {
           next()
         }
       }
     }
    
    

    
  }
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js